import { gql } from 'apollo-boost';

export const mapShapesSet = gql`
    mutation mapShapesSet($input: MapShapesSetMutationInput!) {
        mapShapesSet(input: $input) {
            mapShapes {
                id
                name
                shape {
                    id
                    geojsonUrl
                    shapeGroup {
                        id
                        name
                    }
                }
            }
            clientMutationId
        }
    }
`;
